import axios from 'axios';

export const aiNoteService = {
    generateSessionNote: (apptId, formId) =>
        axios.post(`/notes/ai/session-note/${apptId}`, formId ? { formId } : undefined, { auth: true }),
};
